"use strict";

var Backbone            = require("backbone");
var _                   = require("underscore");

var AnnotationModel     = require("../models/annotation-model");

/**
 * AnnotationCollection 
 */
module.exports = Backbone.Collection.extend({
  
    model:AnnotationModel,
    rnapi:null,
    publicationId:0,
    documentId:0,

    initialize: function (models, options) {
        _.extend(this, options);
    },

    url: function() {
        var T=this;
        return T.rnapi+"/documents/"+T.publicationId+"/"+T.documentId+"/annotations";
    }

});